import { render, staticRenderFns } from "./PresidiPrestazioniListPage.vue?vue&type=template&id=b103ccce"
import script from "./PresidiPrestazioniListPage.vue?vue&type=script&lang=js"
export * from "./PresidiPrestazioniListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports